"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConditionalCardActionButton = void 0;
const isConditionalCardActionButton = (conditionalActionButton) => 'canBePrimary' in conditionalActionButton;
exports.isConditionalCardActionButton = isConditionalCardActionButton;
//# sourceMappingURL=config.js.map